export const InnerGlowLogo = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`} aria-label="InnerGlow Productions">
      <svg
        width="26"
        height="26"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
        aria-hidden="true"
      >
        <circle cx="20" cy="20" r="18" stroke="currentColor" strokeWidth="1" opacity="0.4" />
        <circle cx="20" cy="20" r="9" stroke="currentColor" strokeWidth="1" />
        <circle cx="20" cy="20" r="2.4" fill="currentColor" />
        <line x1="20" y1="2" x2="20" y2="9" stroke="currentColor" strokeWidth="1" />
        <line x1="20" y1="31" x2="20" y2="38" stroke="currentColor" strokeWidth="1" />
      </svg>
      <div className="leading-none">
        <div className="font-sans text-[14px] font-medium tracking-tight">InnerGlow</div>
        <div className="font-sans text-[9px] uppercase tracking-[0.32em] text-muted-foreground mt-[3px] font-light">
          Productions
        </div>
      </div>
    </div>
  );
};
